import { Button, Icon } from '@iq/react-components';

const DegradedQualityIndicator = ({
  message,
  icon: { name = 'he-help', size = 's', color = '#FF7300', className = '' } = {},
}) => (
  <div className="degraded-quality-indicator">
    <Button
      tooltip={message || 'Degraded signal quality'}
      design="text"
      tooltipPosition="bottom-end"
    >
      <Icon
        icon={name}
        size={size}
        color={color}
        className={className}
      />
    </Button>
  </div>
);

export default DegradedQualityIndicator;
